import React from 'react';
import './Header.css';

interface HeaderProps {
  title: string;
  showHomeButton: boolean;
  onGoHome: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, showHomeButton, onGoHome }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          {showHomeButton && (
            <button className="home-button" onClick={onGoHome}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
              </svg>
              Dashboard
            </button>
          )}
          <h1 className="header-title">{title}</h1>
        </div>
        <div className="header-right">
          <div className="user-menu">
            <button className="user-button">
              <span className="user-avatar">CP</span>
              <span className="user-name">Admin</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
